$(function(){

  var wSP = 768;
  var minDisplayHeight = 600;

  /*
    UA mera
  */
  var viewport = document.createElement("meta");
  viewport.setAttribute("name", "viewport");
  console.log('view');
  if (screen.width < wSP) {
    console.log('sp-view');
    viewport.setAttribute("content", "width=device-width, initial-scale=1.0");
  } else {
    console.log('pc-view');
    viewport.setAttribute('content', 'width=1200');
  }
  document.getElementsByTagName("head")[0].appendChild(viewport);


  // ハンバーガーメニュー開閉時
  $('#menu-toggler').on('click', function(){
    $('#gnav').toggleClass("active");
    $('.menu-bar__btn').toggleClass("open");
    // if($(this).hasClass('collapsed')){
    //   $(".navbar").addClass("nav-open");
    // } else {
    //   $(".navbar").removeClass("nav-open");
    // }
  });


  $('.products__slider__list').bxSlider();


  // 問い合わせ送信完了したら、サンクスページに飛ばす
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = '/contact/thanks/';
  }, false );

});



